import { useTranslation } from "react-i18next";

import { cn } from "@/shared/lib/css";
import { Button } from "@/shared/ui/kit/button";

import { TABS, type Tab } from "../domain/types";

type SearchDialogTabsProps = {
  activeTab: Tab;
  onTabChange: (tab: Tab) => void;
};

export function SearchDialogTabs({
  activeTab,
  onTabChange,
}: SearchDialogTabsProps) {
  const { t } = useTranslation();

  return (
    <div className="flex items-center gap-2 px-4 py-3 border-b ">
      {TABS.map((tab) => (
        <Button
          key={tab}
          variant={activeTab === tab ? "default" : "ghost"}
          size="sm"
          onClick={() => onTabChange(tab)}
          className={cn(
            "h-8 px-4 text-sm font-medium rounded-md",
            activeTab === tab
              ? "bg-primary text-primary-foreground hover:bg-primary/90"
              : "text-muted-foreground hover:text-foreground hover:bg-muted",
          )}
        >
          {t(`search.tabs.${tab}`)}
        </Button>
      ))}
    </div>
  );
}
